















import Loader from '@/components/common/Loader.vue';
import { Component, Vue } from 'vue-property-decorator';
import { registrationService } from '@/services/RegistrationService';
import { tokenService } from '@/services/TokenService';

@Component({
  components: { Loader },
})
export default class ActivationCode extends Vue {
  isError = false;
  isLoading = false;
  mounted() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    registrationService
      .activate(this.$route.params.token)
      .then((data: any) => {
        this.isLoading = false;
        if (data && data.token) {
          tokenService.saveToken(data.token);
          this.$router.push('/').catch(() => {});
        } else {
          this.isError = true;
        }
      })
      .catch(() => {
        this.isLoading = false;
        this.isError = true;
      });
  }
}
